import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import { LangProvider } from "@/contexts/LangContext";
import { SiteContentProvider } from "@/contexts/SiteContentContext";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import Properties from "@/pages/Properties";
import PropertyDetail from "@/pages/PropertyDetail";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import AddProperty from "@/pages/AddProperty";
import Dashboard from "@/pages/Dashboard";
import Favorites from "@/pages/Favorites";
import Admin from "@/pages/Admin";
import AiAssistant from "@/pages/AiAssistant";
import Terms from "@/pages/Terms";
import { Toaster } from "@/components/ui/sonner";

function Protected({ children, adminOnly = false }) {
  const { user, isLoading } = useAuth();
  if (isLoading) return <div className="p-16 text-center text-slate-500">…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/" replace />;
  return children;
}

function Shell() {
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-1">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/properties" element={<Properties />} />
          <Route path="/property/:id" element={<PropertyDetail />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/sell" element={<Protected><AddProperty /></Protected>} />
          <Route path="/sell/:id" element={<Protected><AddProperty /></Protected>} />
          <Route path="/dashboard" element={<Protected><Dashboard /></Protected>} />
          <Route path="/favorites" element={<Protected><Favorites /></Protected>} />
          <Route path="/admin" element={<Protected adminOnly><Admin /></Protected>} />
          <Route path="/ai" element={<AiAssistant />} />
          <Route path="/ai-property-assistant" element={<AiAssistant />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/privacy" element={<Terms />} />
          <Route path="/disclaimer" element={<Terms />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </main>
      <Footer />
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default function App() {
  return (
    <LangProvider>
      <SiteContentProvider>
        <AuthProvider>
          <BrowserRouter>
            <Shell />
          </BrowserRouter>
        </AuthProvider>
      </SiteContentProvider>
    </LangProvider>
  );
}
